import { Accessor, createEffect, createSignal, untrack } from 'solid-js';

/**
 * 有依赖嵌套的异步resource(async本质上就是resource)处理的一些思路
 * 目的: 为了使所有资源第一次渲染时被顶层suspense收集loading，（页面直出），之后渲染根据各自依赖的suspense而loading
 * 1、有依赖嵌套的resource使用createWritableMemo让一个resource派生的值可写，可覆盖
 * 2、转换一个可写memo(wirtableMemo)为一个Accessor<MaybePromise<T>> 可能为promise类型（MaybePromise）的数据getter
 * 3、在下一个resource内await读取这个MaybePromise
 * const r1 = createAsync(async () => [1, 2, 3]);
 * // 派生可写状态
 * const [select, setSelect] = createWriteableMemo(() => r1()?.[0]);
 * // 转换一个resource的依赖值为promise
 * const rp = createResourcePromise(select);
 * // 使用这个promise控制异步流程
 * const r2 = createAsync(async () => {const select = await rp(); return {select}});
 *
 * 参考代码
 * (
 *  <Suspense fallback={<div>parent loading</div>}>
 *    <div>{JSON.strignify(r1())}</div>
 *    <Show when={rp()} keyed>
 *    {rp => {
 *       const r2 = createAsync(async () => {const select = await rp(); return {select}});
 *       return (<Suspense fallback={<div>child loading</div>}>{JSON.stringify(r2())}</Suspense>)
 *    }}
 *    </Show>
 *  </Suspense>
 * )
 *
 */

// let ssk: symbol | undefined = import.meta.env.SSR
//   ? undefined
//   : (createRoot(() => {
//       let ctx: any;
//       createComputed(() => {
//         <SuspenseBase>{((ctx = getOwner()!.context), null)}</SuspenseBase>;
//       });
//       return Reflect.ownKeys(ctx)[0];
//     }) as any);

// function fixAsyncTransitionSuspense<T extends (...args: any[]) => any>(createFn: T): T {
//   const wrap = (fn: any, options: any) => {
//     const isHydration = import.meta.env.SSR || sharedConfig.context;
//     let res: AccessorWithLatest<T | undefined>;
//     const parent = useSuspenseRootParent();
//     const wrapFn = createMemo<Promise<T>>(async () => {
//       const pms = fn(untrack(() => (res ? res.latest : undefined)));
//       try {
//         const start = Date.now();
//         const pmsRes = await pms;
//         if (!import.meta.env.SSR) {
//           const duration = parent()[1];
//           const diff = duration - (Date.now() - start);

//           if (diff > 0) {
//             await new Promise((res) => setTimeout(res, diff));
//           }
//         }
//         return pmsRes;
//       } finally {
//         first = false;
//       }
//     });
//     // const [pms, setPms] = createSignal<Promise<T | undefined>>((isHydration ? wrapFn() : undefined) as any);
//     // const [pms, setPms] = createSignal<Promise<T | undefined>>(wrapFn());
//     let first = true;
//     // // 1. 解决路由Transition问题
//     // createEffect((pre) => {
//     //   const pms = wrapFn();
//     //   first = pre === undefined;
//     //   setPms(pms);
//     //   return pms;
//     // });
//     // 2. 包装resource
//     res = createFn(wrapFn, {
//       deferStream: true,
//       ...options,
//     });

//     let cache: [() => any, () => void] | undefined;
//     onCleanup(() => {
//       cache?.[1]();
//     });
//     // 3. 设置读取边界
//     let fixRes = isHydration
//       ? res
//       : () => {
//           if (first) {
//             if (!cache) {
//               cache = createRoot((dps) => {
//                 return [
//                   createMemo(() => {
//                     return res();
//                   }),
//                   dps,
//                 ];
//               }, parent()[0]);
//             }
//             return cache[0]();
//           } else {
//             cache?.[1]();
//             cache = undefined;
//             fixRes = res;
//             return res();
//           }
//         };

//     const resultAccessor = createMemo(() => fixRes());
//     Object.defineProperty(resultAccessor, 'promise', {
//       get() {
//         return wrapFn();
//       },
//     });
//     return resultAccessor;
//   };

//   return wrap as unknown as T;
// }

// export interface AccessorWithAsync<T, R = T> {
//   (): T;
//   promise: Promise<R>;
//   latest: T;
// }

// interface CreateAsync {
//   <T>(
//     fn: (prev: T) => Promise<T>,
//     options: {
//       name?: string;
//       initialValue: T;
//       deferStream?: boolean;
//       /** 独立(任何时候都不传播suspense) */
//       standAlone?: boolean;
//     }
//   ): AccessorWithAsync<T>;

//   <T>(
//     fn: (prev: T | undefined) => Promise<T>,
//     options?: {
//       name?: string;
//       initialValue?: T;
//       deferStream?: boolean;
//       /** 独立(任何时候都不传播suspense) */
//       standAlone?: boolean;
//     }
//   ): AccessorWithAsync<T | undefined, T>;
// }
// /**
//  * 修复了嵌套资源的loading问题
//  */
// // export const createAsync = createAsyncBase
// interface CreateAsyncStore {
//   <T>(
//     fn: (prev: T) => Promise<T>,
//     options: {
//       name?: string;
//       initialValue: T;
//       deferStream?: boolean;
//       reconcile?: ReconcileOptions;
//       /** 独立(任何时候都不传播suspense) */
//       standAlone?: boolean;
//     }
//   ): AccessorWithAsync<T>;
//   <T>(
//     fn: (prev: T | undefined) => Promise<T>,
//     options?: {
//       name?: string;
//       initialValue?: T;
//       deferStream?: boolean;
//       reconcile?: ReconcileOptions;
//       /** 独立(任何时候都不传播suspense) */
//       standAlone?: boolean;
//     }
//   ): AccessorWithAsync<T | undefined, T>;
// }
/**
 * 修复了嵌套资源的loading问题
 */
// export const createAsyncStore = createAsyncStoreBase

// /**
//  * 创建一个可以针对async数据选择一块数据进行重写，并生成相应的promise版本给其它async作为依赖
//  * @param source async资源，一般使用createAsync创建
//  * @param selector 选择一块数据作为默认值，当souce变化时将重新选择
//  * @returns
//  */
// export function createAsyncSelector<T, R>(
//   source: AccessorWithAsync<T | undefined, T>,
//   selector: (data: T) => R | undefined
// ): [Accessor<R | undefined> & { promise: Promise<R> }, Setter<R | undefined>] {
//   const [select, setSelect] = createWritableMemo((prev) => {
//     const s = source();
//     return s ? selector(s) : prev;
//   });

//   const [pms, setPms] = createWritableMemo(() => source.promise.then(selector));

//   Object.defineProperty(select, 'promise', {
//     get() {
//       return pms();
//     },
//   });

//   return [
//     select as any,
//     ((value: any) => {
//       const res = setSelect(value);
//       setPms(Promise.resolve(value));
//       return res;
//     }) as any,
//   ];
// }

/**
 * 类似createAsync 它不生成渲染上下文，不会产生水合失败，用来初始化数据
 * 仅在客户端运行时初始化数据，在server端会使用initialValue
 * @param fn 获取数据的方法
 * @param options
 * @returns
 */
export function useResource<T>(
  fn: (prev: T) => Promise<T>,
  options: { initialValue: T }
): Accessor<T> & {
  loading: Accessor<boolean>;
} {
  const [loading, setLoading] = createSignal(false);
  const [data, setData] = createSignal<T>(options.initialValue);
  createEffect(() => {
    setLoading(true);
    const pms = fn(untrack(data));
    pms.then(setData);
    pms.finally(() => setLoading(false));
  });

  return Object.assign(data, {
    loading,
  });
}

// const SuspenseRootContext = createContext<(parent?: Owner | null) => [Owner | null, number]>(() => [null, 0] as any);

// function useSuspenseRootParent() {
//   return useContext(SuspenseRootContext) || (() => [getOwner(), 0]);
// }
/**
 * 包装后的suspense，配合resource的一些必要上下文
 * 默认包装于Presence处理动画
 * 默认缓存fallback，使多次的fallback仅会渲染一个实例(主要用于处理fallback间的动画一致性)
 * @param props
 * @returns
 */
// export function Suspense(
//   props: ParentProps<{
//     fallback?: JSX.Element;
//     /** 在这个Suspense下读取的resource至少要等待的时间，即使是读取缓存也要经历这个时间 */
//     duration?: number;
//     resolved?: boolean;
//   }>
// ) {
//   const parent = useSuspenseRootParent();
//   const duration = props.duration || 0;
//   const parentOwner = getOwner();
//   let resolved: boolean = true;
//   if (!import.meta.env.SSR) {
//     resolved = props.resolved || false;
//     const inFallback = parentOwner!.context[ssk!].inFallback;
//     createEffect(() => {
//       if (!inFallback()) {
//         resolved = true;
//       }
//     });
//   }
//   function render() {
//     const owner = getOwner();
//     // if (!import.meta.env.SSR) {
//     // const inFallback = owner!.context[ssk!].inFallback;
//     // console.log(owner, owner!.context[ssk!])
//     // createComputed(() => {
//     //   console.log('fb', inFallback())
//     // })
//     // }
//     return (
//       <SuspenseRootContext.Provider
//         value={(po) => {
//           if (resolved) {
//             return [po || owner, duration];
//           } else {
//             return parent(parentOwner);
//           }
//         }}
//       >
//         {props.children}
//       </SuspenseRootContext.Provider>
//     );
//   }

//   let fb: JSX.Element;
//   let dps: () => void | undefined;
//   onCleanup(() => dps?.());
//   function fallback() {
//     if (!fb) {
//       const res = createRoot((dps) => {
//         const el = children(() => props.fallback);
//         return [el, dps] as any;
//       });
//       dps = res[1];
//       fb = res[0];
//     }
//     return fb;
//   }

//   return (
//     <Presence>
//       <SuspenseBase fallback={fallback()}>{render()}</SuspenseBase>
//     </Presence>
//   );
// }

/**
 * 转换一个resource成promise，用于处理嵌套resource在SSR和client的依赖
 * @param change
 * @returns
 * const r1 = createAsync(async () => 1);
 * // 转换一个resource值为promise
 * const rp = createResourcePromise(r1);
 * // 使用这个promise控制异步流程
 * const r2 = createAsync(async () => await rp());
 */

// export function createResourcePromise <T>(resource: Accessor<T | undefined>): Accessor<MaybePromise<T>> {
//   let pmsControll: [
//     (data: T) => void,
//     (reason: string) => void
//   ] | undefined = undefined;
//   if (import.meta.env.SSR) {
//     return createMemo(resource) as any;
//   } else {
//     const [value, setValue] = createSignal<T | Promise<T>>(resource() || new Promise((res, rej) => {
//       pmsControll = [res, rej];
//     }));
//     createComputed((pre) => {
//       const newValue = resource();
//       if (newValue !== undefined) {
//         if (pre === undefined) {
//           pmsControll?.[0](newValue);
//         } else {
//           setValue(pre => newValue);
//         }
//       }
//       return newValue;
//     });
//     onCleanup(() => {
//       console.log(value, resource)
//       pmsControll?.[1]('clean');
//     });
//     return value;
//   }
// }

// export type MaybePromise<T> = T | Promise<T>;
